import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
export const show = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '//syntaf.in/g/{key}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
show.url = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { key: args }
    }

    if (Array.isArray(args)) {
        args = {
            key: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        key: args.key,
    }

    return show.definition.url
            .replace('{key}', parsedArgs.key.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
show.get = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
show.head = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
const showForm = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
showForm.get = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ShortlinkController::show
* @see app/Http/Controllers/ShortlinkController.php:169
* @route '//syntaf.in/g/{key}'
*/
showForm.head = (args: { key: string | number } | [key: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const gallery = {
    show: Object.assign(show, show),
}

export default gallery